import { fetch as fetchApi, isString, insert as insertApi, drop as dropApi } from "./api";

import { HashedHotCard, HashedHotCardCodec, Data } from "../store/hashedHotCard/types";
import { flattenData, withDecoded } from "./index";

function mapToModel(data: object): HashedHotCard {
  return withDecoded(HashedHotCardCodec, data, decoded => ({
    ...decoded
  }));
}

export async function fetch(id: string | null | undefined, params?: {}): Promise<HashedHotCard> {
  return fetchApi({
    nestedResourcePath: ["hashedHotCard"],
    id,
    params
  })
    .then(response => {
      return isString(response.data) ? JSON.parse(response.data) : response.data;
    })
    .then(data => mapToModel(flattenData(data)));
}

export async function save(hotcard: Data): Promise<HashedHotCard> {
  console.log(
    "HOTCARD:", hotcard
  )
  //@ts-ignore
  return insertApi({
    nestedResourcePath: ["hashedHotCard"],
    // @ts-ignore.
    id: hotcard.data.id,
    // @ts-ignore
    data: hotcard,
  }).then((response) => {
    return mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data.data) : response.data
      )
    )
  });
}